<template>
  <div
    v-if="membershipPlans">
    <div v-if="showAccountNav">
      <div v-if="isMobile">
        <action-header page-header>
          <h5>Account</h5>
        </action-header>
      </div>
      <div
        v-else>
        <bread-crumb
          class="mb-3 mx-3"
          current-location="Choose Your Membership"
          :crumbs="[{ name: 'Account', to: { name: 'account' } }]"/>
      </div>
    </div>
    <div :class="{ 'pt-4': isMobile && showAccountNav}">
      <h4>{{ isRejoinFlow ? 'Ready to Refresh Your Wardrobe?' : 'Choose Your Membership' }}</h4>
      <p class="text-pewter small-text">
        All Armoire memberships include free shipping both ways, dry cleaning, and personal styling.
      </p>
    </div>
    <div
      class="p-2 my-4 pb-5"
      :class="{ 'membership-desktop': !isMobile }">
      <div class="row">
        <plain-button
          v-for="membershipPlan in membershipPlans.filter(plan => !plan.prepayment)"
          :key="membershipPlan.id"
          class="col py-2 px-lg-1"
          @click="selectPlan(membershipPlan.id, true)">
          <plan-card
            :plan="membershipPlan"
            :selected="membershipPlan.id === membershipPlanSelectedId"
            :header-text="getHeaderText(membershipPlan)"/>
        </plain-button>
      </div>
    </div>
    <div class="bottom-nav justify-content-center">
      <sequin-button
        :disabled="membershipPlanSelected === null"
        type="router-link"
        :to="{ name: 'subscribe', query }"
        class="my-3 w-330"
        :class="{ 'mb-4': isMobile }">
        Next
      </sequin-button>
    </div>
  </div>
</template>

<script>
import PlainButton from '../global/sequin/PlainButton'
import PlanCard from './PlanCard'
import SequinButton from '../global/sequin/SequinButton'
import { storeToRefs, mapActions } from 'pinia'
import { mapState, mapActions as mapVuexActions, mapGetters } from 'vuex'
import { MobileAppMessage, postToMobileWebView } from '@/utils/mobileApp.js'
import { useRejoinStore } from '@/stores/rejoin.js'
import ActionHeader from '@/components/global/sequin/ActionHeader.vue'
import BreadCrumb from '@/components/global/sequin/BreadCrumb.vue'
import { useRoute } from 'vue-router'
import { ref } from 'vue'

export default {
  components: {
    PlainButton,
    PlanCard,
    SequinButton,
    ActionHeader,
    BreadCrumb
  },
  setup () {
    const { latestSubscriptionPlanId, isRejoinFlow } = storeToRefs(useRejoinStore())

    const route = useRoute()
    const showAccountNav = ref(false)
    if (route?.meta?.from?.name === 'account') {
      showAccountNav.value = true
    }
    return {
      latestSubscriptionPlanId,
      isRejoinFlow,
      showAccountNav
    }
  },
  computed: {
    ...mapState('subscribe', [
      'membershipPlanSelectedId',
      'membershipPlans'
    ]),
    ...mapGetters('subscribe', [
      'membershipPlanSelected'
    ]),
    query () {
      if (this.isRejoinFlow) {
        return { rejoin: true }
      } else {
        return {}
      }
    }
  },
  created () {
    if (typeof Stripe === 'undefined') {
      // load the Stripe library (once), the first time the user enters the
      // Subscribe pipeline.  Takes ~300-400ms on a 3G connection, so this
      // will be done a long time before it's actually needed (in
      // SubscribePayment)
      const script = document.createElement('script')
      script.id = '_stripe-checkout-script'
      script.src = 'https://js.stripe.com/v3/'
      script.type = 'text/javascript'
      document.head.appendChild(script)
    }
  },
  updated () {
    // Make sure the default selected plan is attached to the client
    // On resubscribe, the data may not be loaded yet.
    if (this.membershipPlanSelectedId) {
      this.selectPlan(this.membershipPlanSelectedId)
    }
  },
  async mounted () {
    postToMobileWebView(MobileAppMessage.SubscribeLoaded)

    if (this.membershipPlans && this.membershipPlans.length === 1) {
      if (!this.membershipPlanSelected) {
        await this.selectPlan(this.membershipPlans[0].id)
      }
    }
  },
  methods: {
    ...mapVuexActions('subscribe', [
      'selectMembershipPlan'
    ]),
    ...mapActions(useRejoinStore, [
      'latestSubscriptionPlanId'
    ]),
    async selectPlan (planId, trackEvent = false) {
      await this.selectMembershipPlan({ planId, trackEvent })
    },
    getHeaderText (membershipPlan) {
      if (membershipPlan.id === this.latestSubscriptionPlanId) {
        return 'Previous Plan'
      } else if (membershipPlan.prepayment && membershipPlan.shipmentsPerInterval === null) {
        return 'Best Value'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: $default-border;
  z-index: $zindex-fixed;
  background: $white;
}
.membership-desktop {
  width: 80%;
  margin: 0 auto;
}

</style>
